import React from "react";
import { useLocation } from "react-router-dom";
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import { Toaster } from "@shadcn-in-nx/ui/sonner";
import { useAuth } from "../context/AuthContext";
import useStorage from "../hooks/useStorage";
import { useTranslation } from "react-i18next";
import useFavorites from "../Apps/Workflow/hooks/useFavorites";

const ClientLayout = ({ children }) => {
    const { pathname } = useLocation();
    // App-iframe page renders edge-to-edge so the embedded app has the full
    // viewport. Padding is kept for every other client route.
    const isAppIframeRoute = pathname.startsWith("/client/app2/");
    const { t } = useTranslation();
    const [sidebarOpen, setSidebarOpen] = useStorage(
        "clientSidebarOpen",
        "true",
        window.localStorage
    );

    const sideBarOpenBoolean = sidebarOpen === "true";

    const toggleSidebar = () =>
        setSidebarOpen((prev) => (prev === "true" ? "false" : "true"));

    const { user } = useAuth();
    const { favoriteWorkflows } = useFavorites();

    const CLIENT_MENU = React.useMemo(() => {
        const menu = [
            {
                label: t("layout.menu.mainMenu"),
                section: true,
            },
            {
                label: t("layout.menu.yourApps"),
                route: "/client/workflows",
                icon: "LayoutGrid",
            },
        ];

        if (favoriteWorkflows.length > 0) {
            menu.push({
                label: "Favorites",
                section: true,
                collapsable: true,
            });
            favoriteWorkflows.forEach((wf) => {
                const route =
                    wf.internalDomain && wf.workflowType === "APP_V2"
                        ? `/client/app2/${wf.internalDomain}`
                        : `/client/workflows/${wf.publicKey}`;
                menu.push({
                    label: wf.name,
                    route,
                    icon: "Star",
                });
            });
        }

        return menu;
    }, [t, favoriteWorkflows]);

    return (
        <>
            <div className="h-screen flex flex-col">
                <Header
                    toggleSidebar={toggleSidebar}
                    sidebarOpen={sideBarOpenBoolean}
                    home="/client/workflows"
                />
                <div className="flex flex-1 relative overflow-hidden min-h-0">
                    <Sidebar
                        isOpen={sideBarOpenBoolean}
                        menu={CLIENT_MENU}
                        setIsOpen={toggleSidebar}
                        user={user}
                        hideProfile={true}
                    />
                    <main
                        className={`flex-1 overflow-y-auto transition-all duration-300 ${
                            isAppIframeRoute ? "" : "p-3 md:p-3"
                        } ${
                            sideBarOpenBoolean ? "lg:ml-64" : "lg:ml-[68px]"
                        }`}
                    >
                        {children}
                    </main>
                </div>
            </div>
            <Toaster position="top-right" />
        </>
    );
};

export default ClientLayout;
